module.exports = __webpack_public_path__ + "img/sv1.d9a5a815.svg";